import React from "react";
import "./style.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { introdata, meta } from "../../content_option";
import { Link } from "react-router-dom";
import { ThreatGlobe } from "./ThreatGlobe";

const ROLES = [
  introdata.animated.first,
  introdata.animated.second,
  introdata.animated.third,
];

// Types the role lines one after another, char by char, terminal-style.
const useTypedRoles = (speed = 45, linePause = 350) => {
  const [line, setLine] = React.useState(0);
  const [chars, setChars] = React.useState(0);
  React.useEffect(() => {
    if (line >= ROLES.length) return; // all lines typed
    if (chars < ROLES[line].length) {
      const t = setTimeout(() => setChars((c) => c + 1), speed);
      return () => clearTimeout(t);
    }
    const t = setTimeout(() => {
      setLine((l) => l + 1);
      setChars(0);
    }, linePause);
    return () => clearTimeout(t);
  }, [line, chars, speed, linePause]);
  return { line, chars };
};

export const Home = () => {
  const { line, chars } = useTypedRoles();
  return (
    <HelmetProvider>
      <section id="home" className="home">
        <Helmet>
          <meta charSet="utf-8" />
          <title>{meta.title}</title>
          <meta name="description" content={meta.description} />
        </Helmet>
        <div className="home__inner">
          <div className="terminal">
            <div className="terminal__bar">
              <span className="dot dot--r"></span>
              <span className="dot dot--y"></span>
              <span className="dot dot--g"></span>
              <span className="terminal__title mono">drew@jordan: ~/portfolio</span>
            </div>
            <div className="terminal__body mono">
              <p className="line">
                <span className="prompt">$</span> whoami
              </p>
              <h1 className="hero__name">Drew Jordan</h1>
              <ul className="hero__roles">
                {ROLES.map((text, i) => {
                  if (i > line) return null; // not started typing yet
                  const shown = i < line ? text : text.slice(0, chars);
                  const isCurrent =
                    i === line || (line >= ROLES.length && i === ROLES.length - 1);
                  return (
                    <li key={i}>
                      <span className="tick">&gt;</span> {shown}
                      {isCurrent && <span className="caret">_</span>}
                    </li>
                  );
                })}
              </ul>
              <p className="line mt">
                <span className="prompt">$</span> cat about.txt
              </p>
              <p className="hero__desc">{introdata.description}</p>
              <p className="line mt">
                <span className="prompt">$</span> ./navigate --to
              </p>
              <div className="hero__actions">
                <Link to="/portfolio" className="term__btn">
                  [ portfolio ]
                </Link>
                <Link to="/contact" className="term__btn">
                  [ contact ]
                </Link>
              </div>
            </div>
          </div>

          <div className="home__avatar">
            <ThreatGlobe />
            <div className="avatar__caption mono">
              <span className="ok">●</span> live threat map · drag to rotate
            </div>
          </div>
        </div>
      </section>
    </HelmetProvider>
  );
};
